import {
  Box,
  Flex,
  Link,
  Text,
} from '@chakra-ui/react';
import { TRAFFIC_LIGHT_COLOURS as COLOURS, servicePerformanceKpiLegend } from '@src/modules/performance/shared/constants';
import { useServicePerformanceKPI } from '@src/modules/performance/context/reports-api-hooks';
import { mapValueToColourRange, roundKpiValue } from '@src/modules/performance/shared/helpers';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import ReportHeader from './ReportHeader';

const subheader = 'LGA Non-Financial Performance Measures';
const informationSource = {
  title: 'Service Performance',
  content: [
    {
      title: 'Non-financial performance measure achievement',
      description:
  <>
    <Text fontSize="inherit">
      The proportion of targets achieved for the Department of Internal Affairs
      {' '}
      <Link href="https://www.dia.govt.nz/diawebsite.nsf/Files/NFPM-Guidance-Roads-andFootpaths/$file/NFPM-Guidance-Roads-andFootpaths.doc" isExternal>Roads and Footpaths non-financial performance measures</Link>
      {' '}
      in the current 3 year period. Partially achieved targets count as half achieved in the percentage. Non reported targets count as not achieved.
    </Text>
    <IndicatorLegend items={servicePerformanceKpiLegend} />
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Calculated by REG from the results published in the Territorial Authority Annual Report for the financial year.
    <br />
    Results sourced from the Territorial Authority website.
  </Text>,
    },
  ],
};

function ServicePerformanceReportHeader({ ...rest }) {
  const { data: servicePerformanceData, isLoadingKpi } = useServicePerformanceKPI();
  const colour = mapValueToColourRange(servicePerformanceData?.percentageTargetAchieved, 'servicePerformanceKpi');

  return (
    <ReportHeader
      title="Service Performance"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={COLOURS[colour]}
            value={servicePerformanceData?.percentageTargetAchieved !== null && servicePerformanceData?.percentageTargetAchieved !== undefined ? `${roundKpiValue(servicePerformanceData?.percentageTargetAchieved, 5, 1)}%` : null}
            isLoading={isLoadingKpi}
            padding={0}
          />
        </Box>
        <Box>
          <Text fontWeight="bold" color="gray" fontSize="xs">
            Non-financial performance
            <br />
            measure achievement
          </Text>
        </Box>
      </Flex>
    </ReportHeader>
  );
}

export default ServicePerformanceReportHeader;
